import { useEffect, useState } from 'react';

const STORAGE_KEY = 'jfd-cookie-consent';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      setIsVisible(window.localStorage.getItem(STORAGE_KEY) !== 'accepted');
    } catch {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      // Ignore storage failures and still dismiss the banner.
    }
    setIsVisible(false);
  };

  return null;
}
